export default {"src":"/_next/static/media/wifi.34b7ba06.svg","height":40,"width":57,"blurWidth":0,"blurHeight":0};